import React, { Fragment, useState } from 'react';
import { Button, Modal, Spinner } from '@themesberg/react-bootstrap';

function ModalMessage({
  title,
  text,
  showProps,
  funcAccept,
  funcClose
}) {
  const [showSpinner, setshowSpinner] = useState(false);

  const localFuncClose = () => {
    funcClose();
    setshowSpinner(false);
  };
  const localFuncAccept = async () => {
    setshowSpinner(true);
    await funcAccept();
    setshowSpinner(false);
  };
  return (
    <>
      <Modal animation={false}  show={showProps} onHide={funcClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{text}</Modal.Body>
        <Modal.Footer>
          {!showSpinner ? (
            <Fragment>
              <Button variant="secondary" onClick={localFuncClose}>
                Cancelar
              </Button>
              <Button variant="primary" onClick={localFuncAccept}>
                Aceptar
              </Button>
            </Fragment>
          ) : (
            <Spinner animation="border" role="status" variant="danger">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalMessage;
